<template>
  <div class="topBanner">
    <!-- <div class="logo">{{ $store.state.ticketDetail.ticketName }}</div> -->
    <!-- {{ ticketName }} -->
    <div class="logo">{{ $store.state.ticketDetail.ticketName ? $store.state.ticketDetail.ticketName : ticketName }}</div>
    <div class="user" v-if="$cookie.get('ticket_phone')">
      <div class="icon" @click="toPersonalCenter"></div>
      <div @click="toPersonalCenter">{{ $cookie.get('ticket_phone') }}</div>
      <div class="logoOut" @click="logoOut">退出</div>
    </div>
      <logout v-if="!$store.state.isMobile&&showModal" ref="out"></logout>
      <!-- <div class="logoutconfirm">
        <div class="title">您是否要退出登录？</div>
        <div class="btngroup">
          <div class="no">否</div>
          <div class="yes">是</div>
        </div>
      </div> -->
    <!-- <div class="topIcon"></div> -->
    <!-- <div class="bottomIcon"></div> -->
  </div>
</template>

<script>
import logout from '../common/logout.vue'
export default {
  data() {
    return {
      museumName: '',
      ticketName: '',
      showModal:false
    };
  },
  components:{logout},
  watch: {
    '$store.state.ticketDetail.ticketName'(newVal, oldVal) {
      if (sessionStorage.getItem('ticketName')) {
        this.ticketName = sessionStorage.getItem('ticketName')
      }
      if (newVal) {
        sessionStorage.setItem('ticketName', newVal)
        this.ticketName = sessionStorage.getItem('ticketName')
      }

      // console.log(newVal)
    }
  },
  mounted(){
    console.log('mounted')
    this.ticketName = sessionStorage.getItem('ticketName')?sessionStorage.getItem('ticketName'):this.$store.state.ticketDetail.ticketName
  },
  methods: {
    logoOut() {
      console.log(12345)
      this.showModal=true
      // this.$parent.showPop=true
      // this.$parent.fromBanner=true
      // this.$cookie.delete('token')
      // location.href = `${location.origin}${location.pathname}#/ticket/login?museumCode=${this.$store.state.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}${this.$route.query.code ? `&code=${this.$route.query.code}` : ''}`

      // location.href = `http://passport2.chaoxing.com/logout.html?refer=${location.origin}${location.pathname}#/ticket/login?museumCode=${this.$store.state.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}${this.$route.query.code ? `&code=${this.$route.query.code}` : ''}`
    },

    toIndex() {
      this.$router.replace(`/ticket/home?museumCode=${this.$store.state.museumCode}`)
    },
    toPersonalCenter() {
      let query = this.$route.query
      delete query.loginType
      if (!this.$cookie.get('token') && this.$route.query.loginUrl) return location.href = this.$route.query.loginUrl
      if (!this.$cookie.get('token')) return this.$router.push({ name: 'login', query, params: { backOtherPage: 'personalCenter' } })
      query.rType = this.$store.state.ticketDetail.perOn ? 1 : 2
      // delete query.code
      // this.$router.push({path: '/ticket/orders', query})
      this.$router.push({ name: 'personalCenter', query })
    },
  }
}
</script>

<style scoped lang="scss">
.topBanner {
  height: 100px;
  position: relative;

  .topIcon,
  .bottomIcon {
    position: fixed;
    height: 400px;
    width: 250px;
    z-index: -1;
  }

  .topIcon {
    right: 0;
    top: 100px;
    background: url('../../assets/ticket/right_top.png') 0 0/cover no-repeat;
  }

  .bottomIcon {
    left: 0;
    bottom: 0;
    background: url('../../assets/ticket/left_bottom.png') 0 0/cover no-repeat;
  }

  .logo {
    position: absolute;
    height: 50px;
    top: 35px;
    left: 10%;
    cursor: pointer;
    font-family: FZDBSJW;
    font-size: 32px;
    color: #FFE4BC;
  }

  div {
    font-size: 20px;
    color: #FFE4BC;
    height: 33px;
    line-height: 33px;
  }

  .user {
    top: 33px;
    right: 10%;
    position: absolute;
    padding-left: 0.3rem;
    cursor: pointer;

    .icon {
      &::before {
        height: 20px;
        width: 20px;
        background: url('../../assets/ticket/icon_user2.png') 0 0/100% no-repeat;
        content: '';
        display: inline-block;
        margin-right: 10px;
        position: absolute;
        top: 16.5px;
        left: 0.15rem;
      }
    }

    .logoOut {
      margin-left: 0.3rem;
      cursor: pointer;
    }

    div {
      display: inline-block;
    }
  }

}</style>
